import { useRef } from "react";
import { LuUpload } from "react-icons/lu";
import { typography } from "../../../design/tokens";
import {
  DashboardMode,
  useDashboardControlsActions,
  useDashboardMode,
  WorkspaceSection,
} from "../../../view_stores/useDashboardControlsStore";
import { useProjectName } from "../../../view_stores/useProjectConfigStore";
import {
  PreviewMode,
  useProjectPreviewMode,
} from "../../../view_stores/useProjectPreviewStore";
import { ProjectPreviewScreenshotControls } from "../../projectPreview/components/ProjectPreviewScreenshotControls";
import { ProjectDashboardModeSwitch } from "./ProjectDashboardModeSwitch";

export default function ProjectDashboardTopPanel({
  isDisabled,
  panelWidth,
}: {
  isDisabled: boolean;
  panelWidth?: number;
}) {
  const dashboardMode = useDashboardMode();
  const previewMode = useProjectPreviewMode();
  const projectName = useProjectName();

  const { setDashboardMode, setWorkspaceSection } =
    useDashboardControlsActions();

  const containerRef = useRef<HTMLDivElement>(null);

  function onPublishClick() {
    setDashboardMode(DashboardMode.WORKSPACE);
    setWorkspaceSection(WorkspaceSection.PUBLISH);
  }

  return (
    <div
      ref={containerRef}
      className="flex items-center relative border-b border-dark-border"
    >
      {/* Left Section - Matches left panel width */}
      <div
        className="flex items-center gap-4 px-4 py-1"
        style={{ width: panelWidth ? `${panelWidth}px` : 'calc(30% * var(--container-width, 100vw))' }}
      >
        {/* App Title */}
        <div
          className={`${typography.size.base} ${typography.weight.semibold}
          overflow-x-auto whitespace-nowrap flex-1`}
        >
          {projectName}
        </div>
      </div>

      {/* Invisible Divider (1px to match SplitPanel) */}
      <div className="w-px h-full bg-dark-border opacity-0" />

      {/* Right Section - Takes remaining space */}
      <div className="flex-1 flex items-center gap-4 px-4 py-1">
        {/* Mode Switch */}
        <div className="flex items-center gap-2">
          <ProjectDashboardModeSwitch isDisabled={isDisabled} />
          {dashboardMode === DashboardMode.PREVIEW &&
            previewMode === PreviewMode.Desktop && (
              <ProjectPreviewScreenshotControls optionsPosition="bottom-center" />
            )}
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Action Buttons */}
        <div className="flex items-center gap-4">
          <button
            onClick={onPublishClick}
            disabled={isDisabled}
            className="flex items-center justify-center
                  gap-2 w-fit py-2 px-4 rounded-full
                  transition-opacity duration-300 bg-primary-blue text-white hover:opacity-90
                  font-medium text-sm
                  disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <LuUpload size={16} />
            <span>Publish</span>
          </button>
        </div>
      </div>
    </div>
  );
}
